import React, {useEffect, useState} from 'react';
import {genericSellRequest} from 'util/api';
import InputMoney from 'util/InputMoney';
import OfferList from 'components/items/detail/OfferList';
import {usePopup} from 'popup/PopupContext';
import {centsToString} from 'util/cashFormatter';

const SellTab = ({item}) => {
    const [price, setPrice] = useState(() => {

        let initialPrice = 100;
        if (item.getMarketSo()) {
            initialPrice = item.getMarketSo() - 1;
        }
        if (initialPrice < 1) {
            initialPrice = 1;
        }
        return initialPrice;
    });

    const [quantity, setQuantity] = useState(1);
    const [isPriceLessThanBuyOffer, setIsPriceLessThanBuyOffer] = useState(false);
    const {openPopup} = usePopup();

    useEffect(() => {
        let initialPrice = (item.getMarketSo() - 1) || 100;
        if (initialPrice < 0) {
            initialPrice = 100;
        }
        if (initialPrice < 1) {
            initialPrice = 1;
        }
        let initialQuantity = item.getUserQuantity() - 1;
        if (initialQuantity < 1) {
            initialQuantity = 1;
        }
        setQuantity(initialQuantity);
        setPrice(initialPrice);
    }, [item]);

    useEffect(() => {
        setIsPriceLessThanBuyOffer(price <= item.getUserBo() && item.getUserBo() > 0);
    }, [price, item]);

    const handleQuantityChange = (e) => {
        let value = Number(e.target.value);
        if (value > item.getUserQuantity()) {
            value = item.getUserQuantity();
        } else if (value < 1) {
            value = 1;
        }
        setQuantity(value);
    };

    const totalPrice = price * parseInt(quantity || 1, 10);

    const handleSell = async () => {
        if (totalPrice < 1 || isPriceLessThanBuyOffer) {
            return;
        }
        const roundedPrice = Math.round(price);
        await genericSellRequest(item.itemType, quantity, roundedPrice);
    };

    const handleCancelSell = async () => {
        try {
            await genericSellRequest(item.itemType, 0, 0);
        } catch (error) {
            console.error('Error cancelling sell offer:', error);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSell();
        }
    };

    const handleShowBuyOffers = () => {
        openPopup(<OfferList isSell={false} itemType={item.itemType}/>);
    };

    return (
        <div onKeyDown={handleKeyDown} tabIndex="0">
            <div style={{justifyContent: 'center', display: 'flex', marginTop: '100px', marginBottom: '100px'}}>
                {item.isUserSelling() ? (
                    <p>
                        You are
                        selling {item.getUserSellingQuantity()}{item.getUserSellingQuantity() === 1 ? '' : ', each'} for {centsToString(item.getUserSo())}
                        <span
                            style={{color: 'red', cursor: 'pointer', marginLeft: '10px'}}
                            onClick={handleCancelSell}
                        >
                        &#x2716;
                    </span>
                    </p>
                ) : (
                    item.hasUserItem() && (
                        <div style={{display: 'flex', alignItems: 'center', flexWrap: 'wrap'}}>
                            <div style={{marginRight: '1em'}}>
                                <label>
                                    Price: $
                                    <InputMoney
                                        initialValue={price}
                                        onChange={setPrice}
                                        nameClass="item-detail-input-field"
                                    />
                                </label>
                            </div>
                            <div style={{marginRight: '1em'}}>
                                <label>
                                    Quantity:{' '}
                                    <input
                                        type="number"
                                        value={quantity}
                                        min={1}
                                        max={item.getUserQuantity()}
                                        onChange={handleQuantityChange}
                                        style={{width: '2.5em'}}
                                        className="item-detail-input-field"
                                    />
                                </label>
                            </div>
                            <div>
                                <button
                                    onClick={handleSell}
                                    style={{display: 'block', margin: '0 auto'}}
                                    disabled={isPriceLessThanBuyOffer || totalPrice < 1 || isNaN(totalPrice)}
                                >
                                    Sell {isPriceLessThanBuyOffer || totalPrice < 1 || isNaN(totalPrice) ? '' : centsToString(totalPrice)}
                                </button>
                                {isPriceLessThanBuyOffer && (
                                    <p style={{color: 'red', fontSize: 'x-small'}}>
                                        You are buying for {centsToString(item.getUserBo())}
                                    </p>
                                )}
                            </div>
                        </div>
                    )
                )}
            </div>
            {item.isMarketBo() && (

                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div/>
                    <button onClick={handleShowBuyOffers}>
                        Show People Buying
                    </button>
                </div>
            )}
        </div>
    );
};

export default SellTab;